import { render, staticRenderFns } from "./ChartPrazoMedioTotalReclamacoesEncerradasPorCompetencia.vue?vue&type=template&id=2b2807ff&"
import script from "./ChartPrazoMedioTotalReclamacoesEncerradasPorCompetencia.vue?vue&type=script&lang=js&"
export * from "./ChartPrazoMedioTotalReclamacoesEncerradasPorCompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports